import { render } from "./AddedDepartmentTable.vue?vue&type=template&id=21af4c86"
import script from "./AddedDepartmentTable.vue?vue&type=script&lang=js"
export * from "./AddedDepartmentTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__